import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { isValid } from '../../../../../../../utils/validationSummary';

class PropertyText extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {

        const value = e.target.value;
        this.props.handleChange(this.props.property.info.name, value ? value : "");
    }

    render() {

        const className = `input-property-picker ${isValid(this.props.validationSummary, this.props.property) ? '' : 'danger'}`;

        if (this.props.disabled) {
            return null
        }

        return (
            <Row>
                <Col style={{ paddingLeft: '0.5rem' }}>
                    <input
                        className={className}
                        name={this.props.property.info.name}
                        type="text"
                        value={this.props.property.value}
                        onChange={this.handleChange} />
                </Col>
            </Row>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyText);
